import { render, staticRenderFns } from "./BlockNavigation.vue?vue&type=template&id=0cff62bc&scoped=true&"
import script from "./BlockNavigation.vue?vue&type=script&lang=js&"
export * from "./BlockNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BlockNavigation.vue?vue&type=style&index=0&id=0cff62bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff62bc",
  null
  
)

export default component.exports